import "styles/AccountPage.scss";

import { ReactComponent as ForwardIcon } from "app/assets/images/icons/chevron-right-lg.svg";
import React from "react";
import { Link } from "react-router-dom";

export const LinkToPlans: React.FC = () => {
  return (
    <div className="customer_tools_list customer_tools_list--endless">
      <Link
        className="customer_tools_list__item customer_tools_section__link"
        to="/account/plan"
      >
        <p className="customer_tools_list__text">
          <strong>Plans & rates</strong>
        </p>
        <ForwardIcon />
      </Link>
    </div>
  );
};
